<template>
  <div>
    <h2>Substituição de Tokens</h2>
    <v-card>
      <v-container fluid>
        <v-card class="mb-2">
          <v-card-title>
            Substituindo tokens do ativo {{ code }}
          </v-card-title>
          <v-card-text>

            <v-row>
              <v-col>
                <p>Importante: Na substituição de ativos, tokens já vendidos e certificados já emitidos podem ser substituídos substituídos por um novo ativo.</p>
              </v-col>
            </v-row>

            <v-row class="pt-4">
              <v-col>
                <h3>Ativo a ser substituído</h3>
              </v-col>
            </v-row>

            <v-row align="center">

              <v-col
                  class="d-flex"
                  cols="6"
                  sm="6"
              >
              <v-select
                    v-model="from_registration_id"
                    :items="registrations"
                    label="De"
                    item-value="id"
                    item-text="label"
                    single-line
                    hide-details
                    clearable
                ></v-select>
              </v-col>
            </v-row>

            <v-row class="pt-4">
              <v-col>
                <h3>Quantidade a ser substituída</h3>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="d-flex" cols="6" sm="6">
                  <v-text-field
                      v-model="amount"
                      label="Quantidade a ser substituída"
                      class=""
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
              </v-col>
            </v-row>
            
            <v-row class="pt-4">
              <v-col>
                <h3>Ativo que irá substituir</h3>
              </v-col>
            </v-row>
            
            <v-row align="center">

              <!-- <v-col class="d-flex" cols="4" sm="4">
                  <v-text-field
                      v-model="code"
                      label="Ativo"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
              </v-col> -->
              
              <v-col
                  class="d-flex"
                  cols="6"
                  sm="6"
              >
                <v-select
                    v-model="to_registration_id"
                    :items="registrations"
                    label="Para"
                    item-value="id"
                    item-text="label"
                    single-line
                    hide-details
                    clearable
                ></v-select>
              </v-col>
            </v-row>

            <v-row class="pt-4">
              <v-col>
                <h3>Proporção (Quantos tokens novos equivalem a um token substituído).</h3>
                <h5>Exemplo: <span class="text-decoration-underline">1000</span> tokens novos de 1kg valem 1 token substítuido de 1 ton (tonelada).</h5>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="d-flex" cols="6" sm="6">
                  <v-text-field
                      v-model="proportion"
                      label="Proporção (X do ativo a substituir equivalem a 1 de substituído)"
                      class=""
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="pt-4">
              <v-col>
                <h3>Segurança</h3>
              </v-col>
            </v-row>

            <v-row>
              <v-col class="d-flex" cols="6" sm="6">
                  <v-text-field
                      v-model="password"
                      label="Digite a senha do administrador"
                      class=""
                      type="password"
                      single-line
                      hide-details
                      clearable
                  ></v-text-field>
              </v-col>
            </v-row>

            <v-row class="pt-8">
              <v-card-actions>
                <v-btn
                    color="teal darken-3"
                    text
                    @click="replace()"
                >
                  Substituir ativos
                </v-btn>
              </v-card-actions>
            </v-row>
          </v-card-text>
        </v-card>
      </v-container>
    </v-card>

    <div>
      <v-overlay
          :value="isLoading"
      >
        <v-progress-circular
            :indeterminate="isLoading"
            size="90"
        >
          Loading...
        </v-progress-circular>
      </v-overlay>
    </div>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Api from "../../services/api.service";

export default {
  name: "replacementToken",
  props: {
    code: {
      type: String|Number,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
    isLoadingGenerate: true,
    data: [],
    filteredTokens: [],
    users: [],
    lotes: [],
    documents: [],
    params: {},
    item: [{id: "all", name: "Ver Todos"}, {id: "certificate", name: "Certificados"},
      {id: "emited", name: "Emitidos"}, {id: "free", name: "A emitir"}],
    detail: false,
    
    from_registration_id : null,
    to_registration_id : null,
    password : '',
    amount : '',
    proportion: '',

    page: 1,
    page_atual: 1,
    perPage: 171,
    sortBy: 'id',
    totalPages: 0,
    dialogGenerate: false,
    tokenEspecific: [],
    registrations: []
  }),

  watch: {
    page: function () {
    },
    searchFilter: {
      handler() {
        this.page = 1;
      },
      deep: true,
    },
  },
  mounted() {
    this.loadRegistrations();
  },

  methods: {
    ...mapMutations(["showSnackbar"]),

    openModal() {
      this.dialogGenerate = true;
      this.overlay = false;
    },

    closeDetailsModal() {
      this.detail = false;
    },

    getFor(value) {
      let res = null;
      for (const val of value){
        res = val;
      }
      return res
    },

    loadRegistrations() {
      this.isLoading = true;
      Api.get(`actives-replacement`).then((response) => {
        //console.log(response.data);
        this.registrations = response.data;
        if(code) {
          response.data.map((el) => {
            if(el.active_id+'' === code+'') {
              this.from_registration_id = el.id;
            }
          });
        }
      }).finally(() => setTimeout(() => (this.isLoading = false), 300));
    },

    replace() {
      if(confirm("Você ter certeza que deseja substituir os ativos?")) {
        this.isLoading = true;
        Api.post(`actives-replacement`, {
          from_registration_id: this.from_registration_id,
          to_registration_id: this.to_registration_id,
          proportion: this.proportion,
          password: this.password,
          amount: this.amount
        }).then((response) => {
            this.showSnackbar({
              text: "Ativo substituído com sucesso!",
              color: "success",
            });
            this.from_registration_id = null;
            this.to_registration_id = null;
            this.password = '';
            this.amount = '';
            this.proportion = '';
        }).catch((error) => {
          if(error.response?.data?.message) {
            this.showSnackbar({
              text: error.response?.data?.message,
              color: "error",
            });
          }else{
            this.showSnackbar({
              text: "Ops! Ocorreu um erro ao substituir.",
              color: "error",
            });
          }
        }).finally(() => setTimeout(() => (this.isLoading = false), 300));
      }
    }

  }
}
</script>

<style scoped>

</style>